import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AccountService } from 'src/app/shared/services/account.service';

@Component({
  selector: 'app-notification-flex-availability',
  templateUrl: './notification-flex-availability.component.html',
  styleUrls: ['./notification-flex-availability.component.scss'],
})
export class NotificationFlexAvailabilityModal {
  constructor(
    public modalController: ModalController,
    public accountService: AccountService,
  ) {}
}
